<template>
    <section class="container hidden-first">
        <div class="row-custom">
            <div class="about-col">
                <h1 class="section-heading">De praktijk</h1>
                <p class="par-spacing">
                    Sinds 1 februari 2025 is de praktijk overgenomen van de heer Van der Staay. Wij zetten zijn jarenlange traditie van zorg en kwaliteit voort, met dezelfde toewijding en persoonlijke benadering die u gewend bent.
                </p>
                <p class="par-spacing">
                    Wij bieden hoogwaardige tandheelkundige zorg met moderne technieken en een persoonlijke aanpak. Ons ervaren team luistert naar uw wensen en zorgt voor de beste zorg voor uw gebit.
                </p>
                <p class="par-spacing">
                    We begrijpen dat een tandartsbezoek spannend kan zijn. Daarom creëren we een ontspannen en vertrouwde omgeving waarin u zich prettig voelt.
                </p>
                <p class="par-spacing">
                    Preventie is onze focus. We controleren, reinigen en adviseren om tandproblemen te voorkomen. Bij behandelingen nemen we de tijd om samen de beste aanpak te kiezen, met transparantie en betrokkenheid.
                </p>
                <p class="par-spacing">
                    Samen zorgen we voor een stralende, gezonde glimlach. Een glimlach om trots op te zijn!
                </p>
                <!-- <a href="" class="hero-btn red-btn">Steun ons</a> -->
            </div>
            <div class="about-col image-col-right">
                <img src="../assets/images/Wachtkamer.jpg" id="the-practice-img">
                <!-- <i class="fa-solid fa-question"></i> -->
            </div>
        </div>

        <div class="kids-corner">
            <h3>Kindvriendelijke speelhoek</h3>
            <p>
                Voor kinderen hebben we bij de behandelkamer een interactieve speelmuur
                en een verrassing-automaat. Zo maken we het bezoek leuker en ontspannen
                voor het hele gezin.
            </p>

            <div class="kids-gallery">
                <figure class="kids-photo-card">
                    <img src="../assets/images/speelmuur.jpg" alt="Interactieve speelmuur voor kinderen in de wachtruimte van Tandzorg Gestel">
                    <figcaption>Interactieve speelmuur</figcaption>
                </figure>

                <figure class="kids-photo-card">
                    <img src="../assets/images/verrassing-automaat.jpg" alt="Verrassing-automaat voor kinderen in de wachtruimte van Tandzorg Gestel">
                    <figcaption>Verrassing na de afspraak</figcaption>
                </figure>
            </div>
        </div>
    </section>
</template>

<script>
export default {
name: "ThePractice",
mounted(){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Home - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Home pagina website milad.");
      
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show-first {
  opacity: 1;
  transform: translateX(0);
}
.about-col {
    flex-basis: 48%;
    /* padding: 30px 2px; */
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}
.about-col img {
    width: 100%;
    max-width: 600px;
}
.about-col h1 {
    padding-top: 0;
}
.about-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}
.par-spacing {
    margin-bottom: -5px;
}

.section-heading {
    color: var(--blue);
    font-size: 3.2rem;
    line-height: 1.2;
    margin-bottom: 0.8rem;
}

.kids-corner {
    margin-top: 3.5rem;
    margin-bottom: 2.8rem;
    padding: 2.2rem;
    border-radius: 12px;
    background: #f8fbfb;
    border: 1px solid rgba(0, 184, 184, 0.16);
}

.kids-corner h3 {
    color: var(--blue);
    font-size: 2.2rem;
    margin-bottom: 0.8rem;
}

.kids-corner p {
    font-size: 1.5rem;
    color: var(--light-color);
    margin-bottom: 1.8rem;
    line-height: 1.7;
}

.kids-gallery {
    display: grid;
    grid-template-columns: repeat(2, minmax(260px, 1fr));
    justify-content: center;
    align-items: stretch;
    gap: 2rem;
    max-width: 980px;
    margin: 0 auto;
}

.kids-photo-card {
    margin: 0;
    background: var(--white);
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(0, 184, 184, 0.12);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.kids-photo-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 34px rgba(0, 0, 0, 0.14);
}

.kids-photo-card img {
    display: block;
    width: 100%;
    height: 330px;
    object-fit: cover;
    object-position: center;
}

.kids-photo-card img {
    transform: rotate(90deg) scale(1.35);
}

.kids-photo-card figcaption {
    padding: 1.2rem 1.3rem 1.4rem;
    font-size: 1.5rem;
    color: var(--black);
    font-weight: 600;
    text-align: center;
}

@media(max-width: 978px) {
    .about-col {
        flex-basis: 48%;
        /* padding: 10px 2px; */
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }
    h3 {
        font-size: 16px;
    }

    .about-col img {
        max-width: 100%;
    }

    .about-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
        margin-top: 25px;
        margin-bottom: 7px;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    }

    .kids-corner {
        margin-top: 2.2rem;
        padding: 1.6rem;
    }

    .kids-corner h3 {
        font-size: 2rem;
    }

    .kids-corner p {
        font-size: 1.4rem;
        margin-bottom: 1.4rem;
    }

    .kids-gallery {
        grid-template-columns: 1fr;
        justify-items: center;
    }

    .kids-photo-card {
        width: min(100%, 420px);
    }

    .kids-photo-card img {
        height: 260px;
    }

}
</style>